import React from 'react';
import { Button, Collapse, Stack, Text, useDisclosure } from '@chakra-ui/react';
import { PopoverIcon } from './PopoverIcon';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useGlobalContext } from '../../context/GlobalContext';

export const DocumentCollapse = () => {
    const { isOpen, onToggle } = useDisclosure();
    const navigate = useNavigate(); // Initialize useNavigate
    const [{ config }] = useGlobalContext();

    const handleNavigation = (route) => {
        if (!config?.inOperation) {
            navigate(route); // Navigate to the specified route
        } else {
            alert('Esta en operación activa, termine la operación para poder acceder a esta sección');
        }
    };

    const menuItems = [
        //{ label: 'Embarques', route: '/embarques' },
        { label: 'Etiquetas', route: '/list-printed-tags' },
        { label: 'Operaciones', route: '/list-operations' },
    ];

    return (
        <>
            <Button justifyContent="space-between" variant="tertiary" size="lg" onClick={onToggle}>
                <Text as="span">Reportes</Text>
                <PopoverIcon isOpen={isOpen} />
            </Button>
            <Collapse in={isOpen} animateOpacity>
                <Stack spacing="1" alignItems="stretch" ps="4">
                    {menuItems.map((item) => (
                        <Button
                            key={item.label}
                            variant="tertiary"
                            size="lg"
                            justifyContent="start"
                            onClick={() => handleNavigation(item.route)} // Navigate on click
                        >
                            {item.label}
                        </Button>
                    ))}
                </Stack>
            </Collapse>
        </>
    );
};
